import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreAutoclosureDisputeComponent } from './cre-autoclosure-dispute/cre-autoclosure-dispute.component';
import { CollapsiblePanelLightModule } from '../collapsible-panel-light/collapsible-panel-light.module';
import { MoreInfoComponent } from './more-info/more-info.component';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../../shared.module';
import { ReviewSubmittedInfoComponent } from './review-submitted-info/review-submitted-info.component';
import { ToasterComponentModule } from '../toaster-component/toaster-component.module';

@NgModule({
  declarations: [
    CreAutoclosureDisputeComponent,
    MoreInfoComponent,
    ReviewSubmittedInfoComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    CollapsiblePanelLightModule,
    ToasterComponentModule,
    SharedModule
  ],
  exports: [CreAutoclosureDisputeComponent]
})
export class CreAutoclosureDisputeModule { }
